import http from '@/services/http';

export interface ApiUser {
  id: string;
  name: string;
  email: string;
  role: string;
  team: string | null;
  active: boolean;
  status: string;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface ApiUserListResponse {
  items: ApiUser[];
  total: number;
  limit: number;
  offset: number;
}

export interface CreateUserPayload {
  name: string;
  email: string;
  password: string;
  role: string;
  team?: string | null;
  active: boolean;
}

export interface UpdateCurrentUserPayload {
  name?: string;
  email?: string;
  team?: string | null;
  password?: string;
}

export interface UpdateUserByAdminPayload {
  name?: string;
  email?: string;
  role?: string;
  team?: string | null;
  active?: boolean;
  password?: string;
}

export async function listUsers(params?: { search?: string; role?: string; active?: boolean; limit?: number; offset?: number }) {
  const response = await http.get<ApiUserListResponse>('/api/users', {
    params: {
      search: params?.search || undefined,
      role: params?.role || undefined,
      active: params?.active,
      limit: params?.limit ?? 200,
      offset: params?.offset ?? 0,
    },
  });

  return response.data;
}

export async function createUser(payload: CreateUserPayload) {
  const response = await http.post<ApiUser>('/api/users', payload);
  return response.data;
}

export async function deleteUser(userId: string) {
  await http.delete(`/api/users/${userId}`);
}

export async function updateCurrentUser(payload: UpdateCurrentUserPayload) {
  const response = await http.patch<ApiUser>('/api/users/me', payload);
  return response.data;
}

export async function updateUserByAdmin(userId: string, payload: UpdateUserByAdminPayload) {
  const response = await http.patch<ApiUser>(`/api/users/${userId}`, payload);
  return response.data;
}